import {Button} from "@progress/kendo-react-buttons"
import {Field} from "@progress/kendo-react-form"
import {Loader} from "@progress/kendo-react-indicators"
import {useInternationalization} from "@progress/kendo-react-intl"
import {Popup} from "@progress/kendo-react-popup"
import {useRef, useState} from "react"
import {updateLaneFeesForBooking} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../store"
import NumberInputField from "./numberInputField"

const LaneFeesNumberInput = ({updateTotalAmount}: {updateTotalAmount: (laneFee: number) => void}) => {
    const intl = useInternationalization()
    const dispatch = useAppDispatch()
    const motCustomPrice = useAppSelector((state: RootState) => state.containers.motBooking.motCustomPrice)
    const hasCustomPrice = useAppSelector((state: RootState) => state.containers.motBooking.hasCustomPrice)
    const checkingCustomPrice = useAppSelector((state: RootState) => state.containers.motBooking.checkingCustomPrice)

    const [show, setShow] = useState(false)

    const anchor = useRef<any>()
    const contentRef = useRef<any>()
    const blurTimeoutRef = useRef<any>()

    const onOpenSchPopover = () => {
        contentRef.current.focus()
    }

    const onFocusSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
    }

    const onBlurSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 100)
    }

    const onBlurTimeout = () => {
        setShow(false)
    }

    const showCustomPrice = () => {
        setShow(!show)
    }

    const formatCurrency = (amount: number) => intl.formatNumber(amount, "c")

    const applyCustomPriceValue = (value: number) => {
        dispatch(updateLaneFeesForBooking(value))
        setShow(false)
    }

    return (
        <>
            <Field
                name="laneFee"
                component={NumberInputField}
                label="Lane fees"
                updateTotalAmount={updateTotalAmount}
            />
            <button
                hidden={!hasCustomPrice && !checkingCustomPrice}
                type="button"
                className="k-button k-button-md k-button-rectangle k-button-flat k-button-flat-primary"
                onClick={() => {
                    if (checkingCustomPrice) {
                        return
                    } else {
                        showCustomPrice()
                    }
                }}
                ref={anchor}
            >
                {checkingCustomPrice ? (
                    <Loader style={{width: "14px"}} size="small" />
                ) : (
                    <span title={"Apply custom price"} className="fa fa-tag"></span>
                )}
            </button>
            <Popup
                anchor={anchor.current}
                anchorAlign={{
                    horizontal: "right",
                    vertical: "bottom",
                }}
                popupAlign={{
                    horizontal: "right",
                    vertical: "top",
                }}
                show={show}
                onOpen={onOpenSchPopover}
                popupClass={"popup-content"}
            >
                <div
                    style={{width: "300px"}}
                    ref={contentRef}
                    tabIndex={0}
                    onFocus={onFocusSchPopover}
                    onBlur={onBlurSchPopover}
                >
                    <div className="text-overflow font-weight-bold text-muted">Custom price available</div>
                    <hr className="mt-1 mb-1" />
                    <div className="d-flex justify-content-between">
                        <div className="me-2">{motCustomPrice?.customPrice}</div>
                        <div>{motCustomPrice && formatCurrency(motCustomPrice.value)}</div>
                    </div>
                    <div className="d-flex justify-content-end pt-2">
                        <Button
                            fillMode="flat"
                            themeColor={"primary"}
                            size="small"
                            style={{
                                cursor: "pointer",
                                lineHeight: "1rem",
                                padding: "4px 12px",
                            }}
                            onClick={(e: any) => motCustomPrice && applyCustomPriceValue(motCustomPrice.value)}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </Popup>
        </>
    )
}

export default LaneFeesNumberInput
